import React from 'react';
import Panel from '@views/Onboarding/panels/Panel';
import CopySection, { FinishStepButton } from '@views/Onboarding/panels/CopySection';
import { WordSeparator } from '@components/Login/AuthOptions';
import { useAuthContext } from '@repo/hooks';
import { useNavigate } from 'react-router-dom';
import styles from './Signup.module.scss';
import BirthdayGraphic from '../BirthdayGraphic';
import LoginOverlay from '@components/Login/Overlay';

export default function Finish() {
  const { user } = useAuthContext();
  const navigate = useNavigate();

  if (!user) {
    return null;
  }

  return (
    <Panel>
      <CopySection>
        <h2>Thank you</h2>
        <p>
          Thanks for adding your birthday to Clay! This will help your friends who would like to
          stay up-to-date with you.
        </p>
        <p>Click below to go to the Clay Home view.</p>
      </CopySection>
      <BirthdayGraphic />
      <FinishStepButton onClick={() => navigate('/')}>Go to Home</FinishStepButton>
    </Panel>
  );
}

export function SignupOverlay({ userHasExistingAccount }: { userHasExistingAccount: boolean }) {
  let copy = 'Thank you for adding your birthday to Clay!';
  let separator = 'Sign in';

  if (!userHasExistingAccount) {
    copy = `${copy} If you'd like, create your own Clay account to manage your relationships thoughtfully.`;
    separator = 'Sign up for Clay';
    localStorage.setItem('signup_from_birthday', '1');
  }

  return (
    <LoginOverlay
      userMessage="Thank you"
      copyAfterMessage={
        <div className={styles.signupMessage}>
          <p>{copy}</p>
          <WordSeparator word={separator} />
        </div>
      }
      className={styles.loginPanel}
    />
  );
}
